import HSApi from '../HSApi';
import { Icd10ItemResponse } from './icd10-item.response';
import { SearchIcd10Response } from './search-icd10.response';

export async function searchIcd10(codeOrName: string, page = 0, size = 20): Promise<Icd10ItemResponse[]> {
  const res = await HSApi.get<SearchIcd10Response>(`/icd10-definitions?codeOrName=${codeOrName}&page=${page}&size=${size}`);

  return res.data.content;
}
